<template>
  <div id="login">
    <h1>Login</h1>
    <input type="password" name="password" v-model="input.password" placeholder="Password" />
    <button type="button" v-on:click="login()">Login</button>
  </div>
</template>

<script>
    export default {
        name: 'login',
        data() {
            return {
                input: {
                    password: ""
                }
            }
        },
        methods: {
            login() {
                if(this.input.password != "") {
                    if(this.input.password == this.$parent.mockAccount.password) {
                        this.$emit("authenticated", true);
                        this.$router.replace({ name: "home" });
                    } else {
                        alert("The password is incorrect");
                    }
                } else {
                   alert("A password must be present");
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
#login {
    box-sizing: border-box;
    width: 100%;
    max-width: 500px;
    border: 1px solid #CCCCCC;
    background-color: #FFFFFF;
    margin: 15px auto;
    padding: 20px;
    text-align: center;

    input {
      background: none;
      border-bottom: 1px solid #4a4a4a;
      border-radius: 0;
      padding: 15px;
      display: block;
      margin: 15px auto 0;
      width: 200px;
    }

    button {
      background: #F98B02;
      border: none;
      color: #fff;
      display: block;
      height: 47px;
      font-size: 18px;
      margin: 35px auto;
      width: 150px;
    }
}
</style>